//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import dayjs from 'dayjs';
import localizableFormat from 'dayjs-ext/plugin/localizableFormat';
import InfiniteLoading from 'vue-infinite-loading';
import { checkGradient } from '~/static/images/index';
import { ARTICLE_TYPE } from '~/static/constants.js';
import PrepFooter from '~/components/ReusableComponents/PrepFooter.vue';
import { BLOG_HEADER_INFO } from '~/constants/blogConstants';
import analyticEvents from '~/services/analyticEvents';

const BlogCardDesktop = () => import('~/components/Articles/DeskComponents/BlogCardDesktop.vue');
const BlogCardMobile = () => import('~/components/Articles/PWAComponents/BlogCardMobile.vue');
// Extend dayjs with the LocalizedFormat plugin
dayjs.extend(localizableFormat);
export default {
    name: 'BlogListing',
    components: {
        BlogCardDesktop,
        BlogCardMobile,
        InfiniteLoading,
        PrepFooter
    },
    inject: ['blogTopic'],
    data() {
        return {
            checkGradient,
            // CONST IMPORT
            ARTICLE_TYPE,
            blogsData: null,
            currentPage: 0,
            blogHeaderInfo: BLOG_HEADER_INFO[this.blogTopic]
        };
    },
    async fetch() {
        if (this.blogTopic) {
            const { data } = await this.$api.articles.getBlogListing(
                this.blogTopic,
                this.currentPage
            );
            this.blogsData = data.data.results.map((item) => this.formatBlogData(item));
        }
    },
    mounted() {
        this.$store.commit('UIElementsState/setSideBarStatus', false);
    },
    methods: {
        formatBlogData(data) {
            const blogData = {
                type: ARTICLE_TYPE.BLOG,
                slug: null,
                topic: null,
                tableOfContentList: null,
                guideContent: null,
                faqSchemaStructure: null,
                articleSchemaStructure: null,
                metaTitle: null,
                metaDescription: null,
                // Specific information for Blog Cards.
                metaInformation: null
            };

            // SEAL
            Object.seal(blogData);
            blogData.slug = `/${this.blogTopic}/${data.slug}`;
            blogData.metaInformation = {
                title: data.data.title,
                subTitle: data.data.metadesc,
                duration: data.data.read_time + ' mins',
                timestamp: dayjs(data.updated_at).format('MMM D, YYYY'),
                imageUrl: data.data.image_url
                    ? '/images/articles/' + data.data.image_url
                    : '/images/articles/1680247840672_topic_q2_2.png'
            };

            return blogData;
        },
        async infiniteHandler($state) {
            this.currentPage += 1;
            const { data } = await this.$api.articles.getBlogListing(
                this.blogTopic,
                this.currentPage
            );
            this.blogsData =
                this.blogsData?.concat(
                    data.data.results.map((item) => this.formatBlogData(item))
                ) || [];
            if (this.blogsData.length === data.data.total) {
                $state.complete();
            } else {
                $state.loaded();
            }
        },
        onCardClick(blogSlugRoute) {
            const trackingEvent = {
                event: analyticEvents.blog_card_clicked,
                data: {
                    blog_url: `${window.location.origin}${blogSlugRoute}`,
                    exam_name: this.blogTopic.toUpperCase()
                }
            };
            this.$store.dispatch('analytics/trackEvent', trackingEvent);
            this.$router.push(blogSlugRoute);
        }
    }
};
